// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"x_L","menu":"x_M"};